import { useCore } from '@/composables/core'
import { useLogger } from '@booksy-com/vue-tools'

import { getFullRouteName } from '@/components/settings/subscription/helpers.js'

export default function (mobile = false) {
  return (route, from, next) => {
    const { store } = useCore()
    const trialMode = store.getters['subscription/trialMode']
    const businessId = store.state.business.business.id
    const yourSubscriptionRouteName = getFullRouteName('your-subscription', mobile)
    const paymentMethodMessage = getFullRouteName('payment-method-info', mobile)
    const subscriptionRouteName = getFullRouteName('', mobile)
    const logger = useLogger('router.guard.trial-mode')

    if (
      !trialMode
      && from.name === yourSubscriptionRouteName
      && route.name === subscriptionRouteName
    ) {
      return next({ name: 'settings' })
    }

    if (
      trialMode
      && ![yourSubscriptionRouteName, paymentMethodMessage]
        .includes(route.name)
    ) {
      logger.warn(`${route.name} restricted by TRIAL mode!`)

      next({
        name: yourSubscriptionRouteName,
        params: { businessId },
      })
    } else {
      next()
    }
  }
}
